import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { StatsBar } from '../components/StatsBar';
import { ValueProps } from '../components/ValueProps';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-292">
      <Header data-id="element-293" />
      <Hero data-id="element-294" />
      <StatsBar data-id="element-295" />
      <ValueProps data-id="element-296" />
      <ContactForm data-id="element-297" />
      <Footer data-id="element-298" />
    </main>;
}